export default {
    intro: '뜻을 보고 알맞은 단어를 골라보세요!',
    th: {
        order: '번호',
        meaning: '문제',
        answer: '정답',
        wrong: '오답',
        wrongChoices: '오답선지',
        correctRate: '정답률',
    },
    manySelectedWrongAnswer: '가장 많이 선택한 오답',
};
